import Accounting from '../Components/Sheets/Accounting/Accounting'

export default function AccountingPage() {
  return <Accounting />
}
